import React, {Component} from 'react';

class Email extends Component {
    render() {
        return <div className="si-card si-push-notifications-card">
            <div className="si-main-text-block">
                <div className="si-text-title">Setup your notifications</div>
                <div className="si-notify-block">
                    <div className="si-notify-row">
                        <span className="si-toggle-text">Transfer and substitution deadlines</span><span
                        className="si-toggle-box">
                            <input id="cbx1" type="checkbox" className="cbx"/>
                            <label for="cbx1" className="lbl"/>
                        </span>
                    </div>
                </div>
                <div className="si-notify-block">
                    <div className="si-notify-row">
                        <span className="si-toggle-text">Transfer and substitution deadlines</span><span
                        className="si-toggle-box">
                            <input id="cbx2" type="checkbox" className="cbx"/>
                            <label for="cbx2" className="lbl"/>
                        </span>
                    </div>
                </div>
                <div className="si-notify-block">
                    <div className="si-notify-row">
                        <span className="si-toggle-text">Transfer and substitution deadlines</span><span
                        className="si-toggle-box">
                            <input id="cbx3" type="checkbox" className="cbx"/>
                            <label for="cbx3" className="lbl"/>
                        </span>
                    </div>
                </div>
                <div className="si-notify-block">
                    <div className="si-notify-row">
                        <span className="si-toggle-text">Transfer and substitution deadlines</span><span
                        className="si-toggle-box">
                            <input id="cbx4" type="checkbox" className="cbx"/>
                            <label for="cbx4" className="lbl"/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default Email;


// WEBPACK FOOTER //
// ./src/components/home/cards/Email.js